
import { apiUrl } from './AxiosHeaders';

function isSuccessResponse(res) {
  const data = res?.data;
  if (!data) return false;
  if (data.status === false) return false;
  if (data.status === true || data.status === 1) return true;
  if (data.success === true) return true;
  if (String(data.Success || "").toLowerCase() === "success") return true;
  return false;
}

export function get_ApiManager(data, url, callback, errorcallback){

  try {
    if(!data){
      apiUrl.get(`${url}`)
      .then(res => {
            if (isSuccessResponse(res)) {
              if (callback != null) callback(res);
            } else if (errorcallback != null) {
              errorcallback(res);
            }
          })
          .catch(err => {
            if(errorcallback != null){
              errorcallback(err);
            }
      })
      } else{
      apiUrl.get(`${url}/${data}`)
      .then(res => {
            if (isSuccessResponse(res)) {
              if (callback != null) callback(res);
            } else if (errorcallback != null) {
              errorcallback(res);
            }
          })
          .catch(err => {
            if(errorcallback != null){
              errorcallback(err);
            }
      })
    }
    } catch (err) {
      console.log(err);
    }
}

export function put_ApiManager(data, edit_id, url, callback, errorcallback){
    apiUrl.put(`${url}/${edit_id}`, data)
    .then(res => {
      if (isSuccessResponse(res) && callback != null) {
        callback(res);
      }
    })
    .catch(err => {
      if(errorcallback != null){
          errorcallback(err);
      }
  })
}

export function delete_ApiManager(id, url, callback, errorcallback){
    apiUrl.delete(`/${url}/${id}`)
      .then(res => {
        if (isSuccessResponse(res) && callback != null) {
          callback(res);
        }
      })
      .catch(err => {
        if(errorcallback != null){
           errorcallback(err);
        }
  })
}

export function post_ApiManager(data, url, callback, errorcallback,customHeaders = {}){
    apiUrl.post(`/${url}`, data,{ headers: { ...apiUrl.defaults.headers, ...customHeaders }})
      .then(res => {
          if (isSuccessResponse(res)) {
            if (callback != null) callback(res);
          } else if (errorcallback != null) {
            errorcallback({ response: { data: res?.data }, message: res?.data?.message });
          }
        })
        .catch(err => {
          if(errorcallback != null){
             errorcallback(err);
          }
    })
}

export function view_ApiManager(url, currentPage, perPage, callback, errorcallback){
    apiUrl.get(`${url}?page=${currentPage}&perPage=${perPage}`)
      .then(res => {
          if (isSuccessResponse(res)) {
            if (callback != null) callback(res);
          } else if (errorcallback != null) {
            errorcallback(res);
          }
        })
        .catch(err => {
          if(errorcallback != null){
             errorcallback(err);
          }
    })
}

export function search_ApiManager(url, data, currentPage, perPage, callback, errorcallback){
  apiUrl.post(`${url}?page=${currentPage}&perPage=${perPage}`, data)
    .then(res => {
        if (isSuccessResponse(res) && callback != null) {
          callback(res);
        }
      })
      .catch(err => {
        if(errorcallback != null){
           errorcallback(err);
        }
  })
}

export function logout_ApiManager(callback, errorcallback){
    apiUrl.get(`/logout`)
      .then(res => {
            if (isSuccessResponse(res) && callback != null) {
              callback(res);
            }
          })
          .catch(err => {
            if(errorcallback != null){
              errorcallback(err);
            }
      })
}

